import { render } from "./StationSelectionPage.vue?vue&type=template&id=bbcbef72&scoped=true&ts=true"
import script from "./StationSelectionPage.vue?vue&type=script&lang=ts"
export * from "./StationSelectionPage.vue?vue&type=script&lang=ts"

import "./StationSelectionPage.vue?vue&type=style&index=0&id=bbcbef72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbcbef72"]])

export default __exports__